import { forwardRef } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

import {
  ACCORDION_DEFAULTS,
  ACCORDION_ITEM_VARIANT_CLASS_MAP,
  type TAccordionItemElement,
  type TAccordionItemProps,
} from "@/ui/components/data-display/Accordion/Accordion.config";
import { cn } from "@/ui/lib/utils";

export const AccordionItem = forwardRef<TAccordionItemElement, TAccordionItemProps>(
  (
    {
      className,
      disabled,
      variant = ACCORDION_DEFAULTS.variant,
      ...props
    },
    ref,
  ) => (
    <AccordionPrimitive.Item
      data-component="AccordionItem"
      ref={ref}
      disabled={disabled}
      className={cn(
        !disabled && variant === "primary" && "hover:shadow-lg",
        "focus-within:ring-4 focus-within:ring-focus-secondary",
        ACCORDION_ITEM_VARIANT_CLASS_MAP[variant],
        className,
      )}
      {...props}
    />
  ),
);

AccordionItem.displayName = AccordionPrimitive.Item.displayName;
